<template>
  <v-dialog :value="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="text-h5"> Create Data View </v-card-title>

      <div class="px-5 my-5">
        <v-text-field
          label="Data View Name"
          placeholder="Data View Name"
          outlined
          v-model="dataView.name"
        ></v-text-field>
      </div>
<div style="padding: 20px">
      <p class="text-h6 pt-4">Fields</p>
      <div>
        <v-row v-for="(item, i) in dataView.fields" :key="i" class="mb-1" dense>
          <v-col>
            <v-text-field
              outlined
              dense
              :value="item.name"
              @input="(val) => updateDataView(`fields[${i}].name`, val)"
              label="Name"
            />
          </v-col>
          <v-col cols="auto">
            <v-btn icon @click="removeInput(i)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-btn
          text
          :disabled="disableAddInput"
          @click="addInput"
          color="primary"
        >
          + Add Input
        </v-btn>

      </div>
</div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')"> Cancel </v-btn>
        <v-btn color="blue darken-1" text @click="saveDataView"> Create </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

const {
  mapActions: dataViewActions,
} = createNamespacedHelpers('DataView');

import cloneDeep from 'lodash/cloneDeep';
import lodashSet from 'lodash/set';

export default {
  name: 'CreateDataView',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataView: {
        fields: [],
        name: '',
      },
    };
  },
  watch: {
    'selectedCustomer.customer_id'() {

    },
  },
  computed: {
    disableAddInput() {
      const inputs = this.dataView.fields;
      if (!inputs) return true;
      if (!inputs[0]) return false;
      const lastInput = inputs[inputs.length - 1];
      return !lastInput?.name;
    },
  },
  mounted() {},
  methods: {
    ...dataViewActions(['createDataView']),
    async updateDataView(prop, value) {
      const dataView = cloneDeep(this.dataView);
      lodashSet(dataView, prop, value);
      this.dataView = dataView;
    },
    removeInput(index) {
      this.dataView.fields.splice(index, 1);
    },
    addInput() {
      const inputs = cloneDeep(this.dataView.fields);
      inputs.push({ name: '' });
      this.dataView.fields = inputs;
    },
    async saveDataView() {
      let schema = {};
      this.dataView.fields.forEach(field => {
        schema[field?.name] = '';
      })
      await this.createDataView({
        schema: schema,
        name: this.dataView.name,
      })
      this.$emit('close')
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'create-data-view';
</style>
